import { createTheme } from '@mui/material/styles';

const commonShape = { borderRadius: 14 };

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#05a5b7', // teal primary
      dark: '#047d8a',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#E2E8F0', // soft gray
    },
    background: {
      default: '#F7FAFC',
      paper: '#FFFFFF',
    },
  },
  shape: commonShape,
  typography: {
    fontFamily: 'Inter, Roboto, Helvetica, Arial, sans-serif',
    h6: { fontWeight: 600 },
    body2: { color: 'rgba(0,0,0,0.65)' },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: commonShape.borderRadius },
        containedPrimary: {
          color: '#ffffff',
          backgroundColor: '#047d8a',
          '&:hover': { backgroundColor: '#036a76' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: commonShape.borderRadius },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: commonShape.borderRadius },
      },
    },
  },
});
